import React from 'react';
import {TextField} from "@mui/material";

const TextFieldObjectWithEntityListSetSimpleValueFixedStripe = ({
                                                                    label,
                                                                    value,
                                                                    setValue,
                                                                    field,
                                                                    entityList,
                                                                    disabled
                                                                }) => {
    return (
        <div>
            <TextField
                autoComplete={"off"}
                disabled={disabled}
                key={field}
                sx={{
                    width: '100%',
                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    gap: '1.5rem',
                }}
                margin="normal"
                select
                label={label}
                value={value === null ? entityList[0].id : value}
                name={field}
                onChange={(e) =>
                    setValue(e.target.value)
                }
                SelectProps={{
                    native: true,
                }}
            >
                {entityList.map((entity) => (
                    <option
                        key={entity.id}
                        value={entity.id}>
                        {entity.length} х {entity.width}
                    </option>
                ))}
            </TextField>
        </div>
    );
};

export default TextFieldObjectWithEntityListSetSimpleValueFixedStripe;